import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import {
  Form,
  Input,
  Upload,
  Button,
  Switch,
  Select,
  Row,
  Col,
  Tabs,
  List,
  Skeleton,
} from "antd";
import { PlusCircleFilled } from "@ant-design/icons";
import { fetchScreenTranslations } from "../../../utils/helpers/translations";
import { useSelector, useDispatch } from "react-redux";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";

import { BsChevronDown, BsPlusLg } from "react-icons/bs";
import { FiSearch } from "react-icons/fi";
import htmlToDraft from "html-to-draftjs";
import { Editor } from "react-draft-wysiwyg";

import {
  RichUtils,
  convertToRaw,
  EditorState,
  ContentState,
  convertFromRaw,
  Modifier,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import { v4 as uuidv4 } from "uuid";

import DocumentUploaderWithProgress from "../../Common/Document_Uploader_With_Progress";
import { getLocalFormatedTime } from "../../../utils/helpers/calculateTime";
import Calender from "../../../assets/icons/Calendar with interaction.svg";
import Clipboard from "../../../assets/icons/clipboard.svg";
import searchIcon from "../../../assets/icons/search.svg";
import plusCircle from "../../../assets/icons/plusCircle.svg";
import send from "../../../assets/icons/send.svg";

import deleteIcon from "../../../assets/icons/Bin.svg";
import statusicon from "../../../assets/icons/Checked.svg";
import Clock from "../../../assets/icons/Clock Icon.svg";
import PlusIcon from "../../../assets/icons/Group 2946.svg";
import Timer from "../../../assets/icons/TimerBlack.svg";
import Stop from "../../../assets/icons/stop-circle.svg";
import Triangle from "../../../assets/icons/triangle.svg";
import TriangleLight from "../../../assets/icons/triangleLight.svg";
import user from "../../../assets/icons/user.svg";
import Icon2 from "../../../assets/images/Group 354.svg";
import AppDatePicker from "../../Common/AppDatePicker";
import { MaintenanceType } from "./MaintenanceType";

import {
  maintainaceStatusList,
  changeMaintenanceStatus,
  assignMaintenence,
  addAssetcomment,
  deleteCheckList,
  deletePO,
  markCheckListComplete,
  updateMaintenance,
  MaintainaceTypeList,
  fetchClientList,
  addNewMaintenance,
  fetchMaintenance,
  GetNextWorkId,
  getMaintenanceList,
} from "../../../redux/actions/maintenanceAction";
import {
  FetchActiveUsers,
  fetchAssetList,
  CheckIfTimeSessionStartOrNot,
  CreateNewTimeSession,
  GetTimeSession,
  UpdateTimeSession,
  setCheckTimeSessionToFalse,
  GetActiveTimeSessionOnPlanboard,
  deleteTaskIdFromTimer,
} from "../../../redux/actions/action";

import {
  GET_TIME_SESSION,
  FETCH_MAINTENANCE_BY_ID,
} from "../../../redux/constants/type";

import "../../../assets/styles/local/TaskMain.css";
import "../../../assets/styles/local/contactTaskPopup.css";
import "../../../assets/styles/local/AddTaskModal.css";
import moment from "moment";
import { ROLES } from "../../../utils/helpers/userRole";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import { handleGeneralNotification } from "../../../utils/helpers/notifications";

const POData = [{ id: "Id 23.01232", name: "Key Handle", status: "pending" }];
export const WorkMaintenanceModal = ({
  assetMaintainaceId,
  showWorkModal,
  setShowWorkModal,
  type,
  from,
  refreshData,
}) => {
  const fetchAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  useEffect(() => {
    fetchScreenTranslations("Workorders-Add").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;

  const asset_Popup_Ref = useRef(null);
  const client_Popup_Ref = useRef(null);

  const dropId = uuidv4();
  const assetId = window.localStorage.getItem("assetId");
  const roleAccess = window.localStorage.getItem("roleid");
  const [statusData, setStatusData] = useState([]);
  const [showStatusDrop, setShowStatusDrop] = useState(false);
  const [statusId, setStatusId] = useState("");
  const [statusName, setStatusName] = useState("");
  const [showDropPeople, setShowDropPeople] = useState(false);
  const [searchPeople, setSearchPeople] = useState("");
  const [itemName, setItemName] = useState("");
  const [showMaintenanceTypeModal, setShowMaintenanceTypeModal] =
    useState(false);
  const [showClientDrop, setShowClientDrop] = useState(false);
  const [percent, setPercent] = useState(0);
  const [checklist, setChecklist] = useState([]);
  const [showAddChecklist, setShowCheckList] = useState(false);
  const [clientSearch, setClientSearch] = useState("");
  const [fullDocPeopleList2, setFullDocPeopleList2] = useState([]);
  const [activeUsers, setActiveUsers] = useState([]);
  const [clientName, setClientName] = useState("");
  const [clientID, setClientID] = useState("");
  const [assetName, setAssetName] = useState("");
  const [assetID, setAssetID] = useState("");
  const [description, setDescription] = useState("");
  const [assignee, setAssignee] = useState([]);
  const [typeOfMaintainance, setTypeOfMaintenance] = useState("");
  const [title, setTitle] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const { TabPane } = Tabs;
  const { Option } = Select;
  const dispatch = useDispatch();
  const statusList = useSelector((state) => state.maintenance.statusList);
  const assetList = useSelector((state) =>
    Object.keys(state.user.assetList).length
      ? state.user.assetList.data.data
      : [],
  );

  const maintenance = useSelector(
    (state) => state.maintenance.maintenanceDetail,
  );

  console.log("asc maintenanceRes", maintenance);

  const clientList = useSelector((state) => state.maintenance.clientList);

  const typeList = useSelector((state) => state.maintenance.maintenanceType);

  const [workId, setWorkId] = useState("");

  console.log("asc56 maintenance", maintenance);

  useEffect(() => {
    if (maintenance && maintenance.workId) {
      if (
        path === "/asset-management/update-facility" ||
        path === "/asset-management/update-part" ||
        path === "/asset-management/update-equipment"
      ) {
        setWorkId(maintenance?.workId);
        setSelectedAssetAddress(maintenance?.assetLocation);

        if (type === "update") {
          setAssetName(maintenance?.general?.assetname);
          setAssetID(maintenance?.general?.assetId);
          setClientName(maintenance?.general?.clientname);
          setClientID(maintenance?.general?.client);
          setDescription(maintenance?.general?.workDescription);
        }
      }
      // assetID
      // assetName

      if (path === "/work-orders" && type === "update") {
        setWorkId(maintenance?.workId);
        setSelectedAssetAddress(maintenance?.assetLocation);

        setAssetName(maintenance?.general?.assetname);
        setAssetID(maintenance?.general?.assetId);
        setClientName(maintenance?.general?.clientname);
        setClientID(maintenance?.general?.client);
        // setDescription(maintenance?.general?.workDescription);
        setDescription((prev) => {
          const apiDesc = maintenance?.general?.workDescription || "";

          // agar pehle kuch nahi hai
          if (!prev) return apiDesc;

          // agar api text already present hai
          if (prev.includes(apiDesc)) return prev;

          // dono ko combine karo
          return apiDesc + "\n" + prev;
        });

        const startTime = maintenance?.startTime;
        console.log("asc56 time", maintenance);

        if (startTime) {
          const [hours, minutes] = startTime?.split(":");
          setHours(hours);
          setMinutes(minutes);
        }
      }
    }
  }, [maintenance, path]);

  // const currentAsset = JSON.parse(localStorage.getItem("currentAsset"));
  const [currentAsset, setCurrentAsset] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      setCurrentAsset(JSON.parse(localStorage.getItem("currentAsset")));
    }, 2000);
  }, []);
  // console.log("asc56 currentAsset", currentAsset);

  useEffect(() => {
    if (
      (currentAsset &&
        type === "add" &&
        path === "/asset-management/update-facility") ||
      path === "/asset-management/update-part" ||
      path === "/asset-management/update-equipment"
    ) {
      setAssetName(currentAsset?.assetName);
      setAssetID(currentAsset?.assetId);

      let ASC_Client2 = clientList?.find(
        (x) => x.clientid === currentAsset?.generalDetails?.client,
      );

      setClientName(ASC_Client2?.clientname);
      setClientID(ASC_Client2?.clientid);

      // console.log("asc56 maintenance", maintenance);
      console.log("asc56 currentAsset", currentAsset);
      console.log("asc56 client22", ASC_Client2);
    }
  }, [currentAsset]);

  const [showplusCircle, setShowplusCircle] = useState(true);
  const companyId = window.localStorage.getItem("companyid");
  const now = new Date();

  // 24Hr format.
  const formattedHours_2 = now.getHours().toString().padStart(2, "0");
  const formattedMinutes_2 = now.getMinutes().toString().padStart(2, "0");

  // 12 Hr format.
  const formattedHours = (now.getHours() % 12 || 12)
    .toString()
    .padStart(2, "0");
  const formattedMinutes = now.getMinutes().toString().padStart(2, "0");

  // const [hours, setHours] = useState(formattedHours);
  const [hours, setHours] = useState("08");
  // const [minutes, setMinutes] = useState(formattedMinutes);
  const [minutes, setMinutes] = useState("00");

  const userlastname = window.localStorage.getItem("lastname");
  const userfirstname = window.localStorage.getItem("firstname");
  const activeStatusResponse = useSelector(
    (state) => state.user.activeStatusResponse,
  );

  const [clients, setClientList] = useState(clientList);

  const emojiPickerRef = useRef(null);
  const [showAddGroupPopup, setShowAddGroupPopup] = useState(false);
  const [calendarStartDateIsOpen, setCalendarStartDateIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [changeComp, setChangeComp] = useState("");
  const [selectedAssetAddress, setSelectedAssetAddress] = useState("");

  console.log("asc445", selectedAssetAddress);

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty(),
  );
  const [showDropPeopleComm, setShowDropPeopleComm] = useState(false);
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [imgUrl, setImgUrl] = useState("");
  const [attachMessage, setAttachMessage] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    setStatusData(statusList);
    setStatusId(statusList[0]?.statusId);
    setStatusName(statusList[0]?.statusName);
  }, [statusList]);

  const fetchNextWorkOrder = async () => {
    let result = await GetNextWorkId();
    setWorkId(result);
  };

  useEffect(() => {
    type === "update" && dispatch(fetchMaintenance(assetMaintainaceId));
    dispatch(MaintainaceTypeList());
    dispatch(fetchClientList());
    dispatch(
      fetchAssetList({
        pageNumber: 1,
        perPageRequired: 10,
        sortby: "Ascnd",
        query: "",
      }),
    );
    dispatch(maintainaceStatusList());
    dispatch(FetchActiveUsers(companyId));

    if (type === "add") {
      fetchNextWorkOrder();
      setDisableTracking(true);
      setIsTimerRunning(false);
      setSession1("00");
      setSession2("00");
      setSession3("00");
      setTotal1("00");
      setTotal2("00");
      setTaskTrackingId("");
    }
  }, []);

  useEffect(() => {
    if (type === "add") {
      console.log("asc433", type);
      // localStorage.removeItem("currentAsset");
      // localStorage.removeItem("assetId");
      // localStorage.removeItem("assetMaintenanceId");
    }
  }, []);

  useEffect(() => {
    if (showWorkModal === false) {
      dispatch({
        type: FETCH_MAINTENANCE_BY_ID,
        data: {},
      });
    }
  }, [showWorkModal]);

  useEffect(() => {
    let timeout;
    if (activeUsers && clientList && assetList && typeList && statusList) {
      if (Object.keys(maintenance).length && type === "update") {
        // if (maintenance?.workId) {
        setTitle(maintenance.maintainaceName);
        setWorkId(maintenance?.workId);

        setStatusName(
          statusList.find((s) => s.statusId === maintenance?.statusId)
            ?.statusName,
        );

        setTypeOfMaintenance(
          typeList.find((t) => t.typeId === maintenance.typeOfMaintainance),
        );

        setStartDate(new Date(maintenance?.startDate));

        if (maintenance?.assignedTo) {
          setAssignee(
            activeUsers.filter((u) => {
              return maintenance?.assignedTo.includes(u.userid);
            }),
          );
        }

        timeout = setTimeout(() => {
          if (maintenance?.assignedTo?.length > 0) {
            const userId = window.localStorage.getItem("userid");
            const isAssigned = maintenance.assignedTo.includes(userId);

            setDisableTracking(!isAssigned);
          }
        }, 1000);

        setMaintainaceId(maintenance?.assetMaintainaceId);

        // dispatch({
        //   type: FETCH_MAINTENANCE_BY_ID,
        //   data: {},
        // });

        dispatch(
          GetTimeSession(
            "00000000-0000-0000-0000-000000000000",
            maintenance?.assetMaintainaceId,
            window.localStorage.getItem("userid"),
            moment(new Date()).format("DD/MM/YYYY"),
            `${new Date().getHours().toString().padStart(2, "0")}:${new Date()
              .getMinutes()
              .toString()
              .padStart(2, "0")}:${new Date()
              .getSeconds()
              .toString()
              .padStart(2, "0")}`,
          ),
        );
        // }

        if (maintenance?.checklist?.length) {
          setChecklist(maintenance?.checklist);
          let check = maintenance?.checklist?.filter(
            (m) => m.isCompleted === true,
          );
          let percentage = (check?.length / checklist?.length) * 100;
          setPercent(percentage);
        }
        // setClientName(
        //   clientList.find((c) => maintenance?.general?.client === c.clientid)
        // );
      }
    }
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [maintenance, assetList, clientList, activeUsers, typeList]);

  useEffect(() => {
    if (activeStatusResponse?.status === true) {
      setFullDocPeopleList2(activeStatusResponse?.data);
      setActiveUsers(activeStatusResponse?.data);
    }
  }, [activeStatusResponse]);

  useEffect(() => {
    if (searchPeople) {
      let people = [...fullDocPeopleList2];
      people = people.filter((people) => {
        const fullName = `${people.firstname} ${people.lastname}`;
        return (
          people.firstname
            ?.toLowerCase()
            .startsWith(searchPeople.toLowerCase()) ||
          people.lastname
            ?.toLowerCase()
            .startsWith(searchPeople.toLowerCase()) ||
          fullName.toLowerCase().startsWith(searchPeople.toLowerCase())
        );
      });

      setActiveUsers(people);
    } else {
      setActiveUsers([...fullDocPeopleList2]);
    }
  }, [searchPeople]);

  useEffect(() => {
    if (clientSearch) {
      let clients = [...clientList];
      clients = clients.filter((item) => {
        return item.clientname
          ?.toLowerCase()
          .startsWith(clientSearch.toLowerCase());
      });

      setClientList(clients);
    } else {
      setClientList([...clientList]);
    }
  }, [clientSearch, clientList]);

  const changeApplied = (e) => {
    setEditorState(e);
    setChangeComp("changed");
  };

  const normalizePastedLists = (html = "") => {
    const doc = new DOMParser().parseFromString(html, "text/html");

    doc.querySelectorAll("li").forEach((li) => {
      li.querySelectorAll("p, div").forEach((element) => {
        element.replaceWith(...Array.from(element.childNodes));
      });
    });

    return doc.body.innerHTML;
  };

  const handleCommentPastedText = (text, html, currentEditorState) => {
    if (!html) return "not-handled";

    try {
      const normalizedHtml = normalizePastedLists(html);
      const pastedBlocks = htmlToDraft(normalizedHtml);

      if (!pastedBlocks?.contentBlocks?.length) {
        return "not-handled";
      }

      const pastedContent = ContentState.createFromBlockArray(
        pastedBlocks.contentBlocks,
        pastedBlocks.entityMap,
      );

      const contentWithPaste = Modifier.replaceWithFragment(
        currentEditorState.getCurrentContent(),
        currentEditorState.getSelection(),
        pastedContent.getBlockMap(),
      );

      const nextEditorState = EditorState.push(
        currentEditorState,
        contentWithPaste,
        "insert-fragment",
      );

      setEditorState(nextEditorState);
      setChangeComp("changed");

      return "handled";
    } catch (error) {
      console.error("Comment paste failed:", error);
      return "not-handled";
    }
  };

  const Wrapper2 = styled.div`
    &:after {
      // content: '"${percent}"';
      position: absolute;
      display: inline-block;
      width: 100%;
      top: 10px;
      text-align: end;
      color: #444141;
      opacity: 50%;
      font-weight: 500;
      font-size: 12px;
    }
  `;
  const handleAddComments = () => {
    console.log("asc45msg", attachMessage);
    console.log("asc45", imgUrl);
    const content = JSON.stringify(
      convertToRaw(editorState.getCurrentContent()),
    );
    dispatch(
      addAssetcomment({
        assetMaintainaceId: assetMaintainaceId ? assetMaintainaceId : assetId,
        comment: content,
        attachments: JSON.stringify(imgUrl),
      }),
    );

    setMessage("");
    // setNewAddedComments([]);
  };

  // asc add comments start.
  // const [displayQuantity, setDisplayQuantity] = useState("5");
  const [showMoreComm, setShowMoreComm] = useState(false);
  let displayQuantity = showMoreComm ? undefined : 5;

  const [newAddedComments, setNewAddedComments] = useState([]);
  console.log("asc56", newAddedComments);

  const handleFinalAddComments = () => {
    const content = JSON.stringify(
      convertToRaw(editorState.getCurrentContent()),
    );

    setNewAddedComments((prev) => [
      {
        addedComments: content,
        attachURL: imgUrl,
      },
      ...prev,
    ]);
  };

  // asc add comments end.

  const handleAddChecklist = (item) => {
    setChecklist([
      ...checklist,
      { name: item.name, isCompleted: item.ischecklist },
    ]);
    let check = checklist.filter((c) => c.isCompleted === true);
    let percentage = (check.length / checklist.length) * 100;

    setPercent(percentage);
    setItemName("");
  };

  const markCheckListCompleted = (index, value) => {
    if (checklist[index].checklistId)
      dispatch(markCheckListComplete(checklist[index].checklistId));
    checklist[index].isCompleted = value;
    setChecklist([...checklist]);
    let check = checklist.filter((c) => c.isCompleted === true);
    let percentage = (check.length / checklist.length) * 100;

    setPercent(percentage);
  };

  const handleDeleteCheckList = (index) => {
    if (checklist[index].checklistId)
      dispatch(deleteCheckList(checklist[index].checklistId));
    setChecklist(checklist.filter((c, i) => i !== index));
    let check = checklist.filter((c) => c.isCompleted === true);
    let percentage = (check.length / checklist.length) * 100;
    setPercent(percentage);
  };

  const selectedUser = (e) => {
    let fullName = `${e?.firstname} ${e?.lastname}`;
    // let afterAt = props.val.split("@")[ 0 ];
    // let afterAt = props.val.split("")[0];
    // let combineValue = afterAt + fullName;
    // props.setVal(combineValue);
    setShowDropPeopleComm(false);
    // props.setTaggedUser([e.userid]);
  };

  const handleHoursKeyDown = (e) => {
    setChangeComp(e.key);
    if (e.key === "Backspace") {
      setHours((prevHours) => prevHours.slice(0, prevHours.length - 1));
    }
  };

  const handleMinutesKeyDown = (e) => {
    setChangeComp(e.key);
    if (e.key === "Backspace") {
      setMinutes((prevMinutes) => prevMinutes.slice(0, prevMinutes.length - 1));
    }
  };

  const handleHoursChange = (e) => {
    setChangeComp(e.target.value);
    const value = e.target.value;
    if (/^\d+$/.test(value) && +value >= 0 && +value <= 23) {
      setHours(value);
      if (value.length === 2) {
        document.getElementById("minutesInput").focus();
      }
    }
  };
  const handleMinutesChange = (e) => {
    setChangeComp(e.target.value);
    const value = e.target.value;
    if (/^\d+$/.test(value) && +value >= 0 && +value <= 59) {
      setMinutes(value);
      if (value.length === 0 && hours.length > 0) {
        document.getElementById("hoursInput").focus();
      }
    }
  };

  // teno same hai but 1 local me set nhi ho rha, baki 2 and 3 set ho rhe hai ListTable.js component 896 me se👇.
  const assetMaintenanceId = localStorage.getItem("assetMaintenanceId");
  const assetMaintenanceId2 = localStorage.getItem("assetId");
  const assetMaintenanceId3 = localStorage.getItem("assetList_AssetId");
  console.log("asc3 get", assetMaintenanceId);

  const handleSubmit = () => {
    let data = {
      associatedAssetId: assetID,
      maintainaceName: title,
      workId: workId,
      assetLocation: selectedAssetAddress,
      typeOfMaintainance: typeOfMaintainance?.typeId,
      startDate: startDate,
      startTime: `${hours}:${minutes}`,
      // endDate: endDate,
      statusId: statusId,
      assignedTo: assignee.map((a) => a.assigneeid || a.userid),
      general: {
        assetId: assetID,
        client: clientID,
        workDescription: description,
      },
      checklist: checklist,
    };
    if (type === "update") {
      dispatch(
        updateMaintenance(
          from
            ? { ...data, assetMaintainaceId }
            : { ...data, assetMaintainaceId, from: "workorder" },
        ),
      );
    } else {
      dispatch(
        addNewMaintenance(from ? { ...data } : { ...data, from: "workorder" }),
      );
    }

    setTimeout(() => {
      refreshData && refreshData();
      dispatch(getMaintenanceList(assetId));
      setShowWorkModal(false);
    }, 1000);
  };
  const onDragEnd = () => {};

  useEffect(() => {
    const newState = RichUtils.toggleInlineStyle(editorState, "BOLD");
    const textMessage = convertToRaw(newState.getCurrentContent());
    setMessage(JSON.stringify(textMessage));
  }, [editorState]);

  const isJson = (item) => {
    let value = typeof item !== "string" ? JSON.stringify(item) : item;
    try {
      value = JSON.parse(value);
    } catch (e) {
      return false;
    }

    return typeof value === "object" && value !== null;
  };

  const getFormattedMessage = (message) => {
    try {
      const rawContent =
        typeof message === "string" ? JSON.parse(message) : message;

      if (!rawContent?.blocks || !rawContent?.entityMap) {
        return message || "";
      }

      const contentState = convertFromRaw(rawContent);

      return draftToHtml(convertToRaw(contentState));
    } catch (error) {
      console.error("Comment formatting error:", error);
      return message || "";
    }
  };

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      asset_Popup_Ref.current &&
      !asset_Popup_Ref.current.contains(event.target)
    ) {
      setShowAddGroupPopup(false);
    }

    if (
      client_Popup_Ref.current &&
      !client_Popup_Ref.current.contains(event.target)
    ) {
      setShowClientDrop(false);
      setClientSearch("");
    }

    // if (type_an_item_Drop_Ref.current && !type_an_item_Drop_Ref.current.contains(event.target)) {
    //   setShowProductsPeople(false);
    // }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  // postal Code start
  const [pinCodeForAdress, setPinCodeForAdress] = useState("");

  const handleAddressSelect = (address) => {
    const { place_id } = address;
    geocodeByPlaceId(place_id)
      .then((res) => {
        console.log("Found the Address", res);

        if (res && res[0] && res[0].address_components) {
          const { long_name: postalCode = "" } =
            res[0].address_components.find((c) =>
              c.types.includes("postal_code"),
            ) || {};
          // setPinCodeForAdress(postalCode);

          if (!address.description.includes(postalCode)) {
            setPinCodeForAdress(postalCode);
          }

          // handleInputChange("mainAsset", address.description + (postalCode ? ', ' + postalCode : ''));

          // handleChange();

          const { formatted_address, address_components } = res[0];
          // setWorkAddress(formatted_address);
          setSelectedAssetAddress(formatted_address);
        }
      })
      .catch((err) => {
        console.log("Error while fetching address meta ", err);
      })
      .finally((done) => {
        console.log("Address API Call Completed ", done);
      });
  };
  // postal Code end

  // work maintainace timer start
  const CheckIfTimeSessionStartOrNotResponse = useSelector(
    (state) => state.user.CheckIfTimeSessionStartOrNotResponse,
  );
  const GetActiveTimeSessionOnPlanboardResponse = useSelector(
    (state) => state.user.GetActiveTimeSessionOnPlanboardResponse,
  );
  const CreateNewTimeSessionResponse = useSelector(
    (state) => state.user.CreateNewTimeSessionResponse,
  );
  const GetTimeSessionResponse = useSelector(
    (state) => state.user.GetTimeSessionResponse,
  );
  const UpdateTimeSessionResponse = useSelector(
    (state) => state.user.UpdateTimeSessionResponse,
  );
  const StopTimerFromHeaderResponse = useSelector(
    (state) => state.user.StopTimerFromHeaderResponse,
  );

  const [disableTracking, setDisableTracking] = useState(true);
  const [isTimerRunning, setIsTimerRunning] = useState(false);

  const [session1, setSession1] = useState("00");
  const [session2, setSession2] = useState("00");
  const [session3, setSession3] = useState("00");
  const [total1, setTotal1] = useState("00");
  const [total2, setTotal2] = useState("00");
  const [taskTrackingId, setTaskTrackingId] = useState("");
  const [maintainaceId, setMaintainaceId] = useState("");

  useEffect(() => {
    if (CheckIfTimeSessionStartOrNotResponse?.status === true) {
      if (!maintainaceId) {
        return handleGeneralNotification({
          notificationType: "CUSTOM",
          text: `Please add a work maintenance first`,
        });
      }
      dispatch(
        CreateNewTimeSession(
          "00000000-0000-0000-0000-000000000000",
          maintainaceId,
          moment().format("DD/MM/YYYY"),
          moment().format("HH:mm:ss"),
          "Work",
          "",
          0,
          window.localStorage.getItem("userid"),
        ),
      );
      dispatch(setCheckTimeSessionToFalse());
    }
    if (CheckIfTimeSessionStartOrNotResponse?.status === false) {
      if (
        CheckIfTimeSessionStartOrNotResponse?.message ===
        "Cannot add another Time"
      ) {
        handleGeneralNotification(
          {
            notificationType: "CUSTOM",
            text: `Timer is already running in ${
              CheckIfTimeSessionStartOrNotResponse?.data?.taskname ||
              GetActiveTimeSessionOnPlanboardResponse?.data?.taskName
            }`,
          },
          false,
        );
        dispatch(setCheckTimeSessionToFalse());
      }
    }
  }, [CheckIfTimeSessionStartOrNotResponse]);

  useEffect(() => {
    if (CreateNewTimeSessionResponse?.status === true) {
      setIsTimerRunning(true);
      window.localStorage.setItem("timerRunning", true);
      window.localStorage.setItem("timerTask", title);
      window.localStorage.setItem(
        "trackingTaskId",
        CreateNewTimeSessionResponse?.data?.projectTaskTrackingTimeid,
      );
      setSession1("00");
      setSession2("00");
      setSession3("00");
      setTaskTrackingId(
        CreateNewTimeSessionResponse?.data?.projectTaskTrackingTimeid,
      );
      dispatch(
        GetActiveTimeSessionOnPlanboard(
          window.localStorage.getItem("userid"),
          moment(new Date()).format("DD/MM/YYYY"),
          `${new Date().getHours().toString().padStart(2, "0")}:${new Date()
            .getMinutes()
            .toString()
            .padStart(2, "0")}:${new Date()
            .getSeconds()
            .toString()
            .padStart(2, "0")}`,
        ),
      );

      // handleGeneralNotification({
      //   notificationType: "CUSTOM",
      //   text: `Your Timer Activity Start`,
      // });
    }
  }, [CreateNewTimeSessionResponse]);

  function timeConvert(n) {
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours).toString().padStart(2, "0");
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes).toString().padStart(2, "0");
    var seconds = (minutes - rminutes) * 60;
    var rseconds = Math.round(seconds).toString().padStart(2, "0");
    setSession1(rhours);
    setSession2(rminutes);
    setSession3(Math.abs(rseconds));
    return `${rhours}:${rminutes}:${rseconds}`;
  }

  useEffect(() => {
    let counter = setInterval(() => {
      if (session2 >= 59) {
        if (session3 >= 59) {
          setSession1((hour) => (+hour + 1).toString().padStart(2, "0"));
          setSession2("00");
          setSession3("00");
          return;
        }
      }
      if (session3 >= 59) {
        setSession2((minute) => (+minute + 1).toString().padStart(2, "0"));
        setSession3("00");
        return;
      }
      setSession3((second) => (+second + 1).toString().padStart(2, "0"));
    }, 1000);
    return () => clearInterval(counter);
  }, [session3]);

  useEffect(() => {
    if (GetTimeSessionResponse?.status === true) {
      let date =
        GetTimeSessionResponse?.data?.currentTimeSession?.trackerStartDate.split(
          "T",
        )[0];
      date = `${date}T${GetTimeSessionResponse?.data?.currentTimeSession?.trackerStartTime}`;
      let diff = new Date().getTime() - new Date(date).getTime();
      timeConvert(diff / 60000);
      let n = new Date(0, 0);
      n.setSeconds(+GetTimeSessionResponse?.data?.totalHoursTracked * 60 * 60);
      let total = n.toTimeString().slice(0, 8);
      setIsTimerRunning(true);
      window.localStorage.setItem("timerRunning", true);
      window.localStorage.setItem("timerTask", title);
      window.localStorage.setItem(
        "trackingTaskId",
        GetTimeSessionResponse?.data?.currentTimeSession
          ?.projectTaskTrackingTimeid,
      );
      setTaskTrackingId(
        GetTimeSessionResponse?.data?.currentTimeSession
          ?.projectTaskTrackingTimeid,
      );
      setTotal1(
        GetTimeSessionResponse?.data?.totalHoursTracked
          .toString()
          .split(".")[0]
          ?.padStart(2, "0"),
      );
      setTotal2(
        GetTimeSessionResponse?.data?.totalHoursTracked
          .toString()
          .split(".")[1]
          ?.padStart(2, "0"),
      );
    } else {
      setIsTimerRunning(false);
      setSession1("00");
      setSession2("00");
      setSession3("00");
      setTotal1(
        GetTimeSessionResponse?.data?.totalHoursTracked
          .toString()
          .split(".")[0]
          ?.padStart(2, "0"),
      );
      setTotal2(
        GetTimeSessionResponse?.data?.totalHoursTracked
          .toString()
          .split(".")[1]
          ?.padStart(2, "0"),
      );
      if (StopTimerFromHeaderResponse?.length > 0) return;
      setTaskTrackingId("");
    }
  }, [GetTimeSessionResponse]);

  useEffect(() => {
    if (UpdateTimeSessionResponse?.status === true) {
      setIsTimerRunning(false);
      window.localStorage.setItem("timerRunning", false);
      window.localStorage.removeItem("timerTask");
      setSession1("00");
      setSession2("00");
      setSession3("00");
      setTaskTrackingId("");
      setTotal1(
        UpdateTimeSessionResponse?.data?.totalHoursTracked
          .toString()
          .split(".")[0]
          ?.padStart(2, "0"),
      );
      setTotal2(
        UpdateTimeSessionResponse?.data?.totalHoursTracked
          .toString()
          .split(".")[1]
          ?.padStart(2, "0"),
      );
      if (StopTimerFromHeaderResponse?.length > 0) return;
      window.localStorage.removeItem("trackingTaskId");
    }
  }, [UpdateTimeSessionResponse]);

  useEffect(() => {
    if (StopTimerFromHeaderResponse?.length > 0) {
      let tracking = window.localStorage.getItem("trackingTaskId");
      dispatch(
        UpdateTimeSession(
          tracking,
          moment(new Date()).format("DD/MM/YYYY"),
          `${new Date().getHours().toString().padStart(2, "0")}:${new Date()
            .getMinutes()
            .toString()
            .padStart(2, "0")}:${new Date()
            .getSeconds()
            .toString()
            .padStart(2, "0")}`,
        ),
      );
      dispatch(deleteTaskIdFromTimer());
    }
  }, [StopTimerFromHeaderResponse]);
  // work maintainace timer end

  return (
    <Modal
      keyboard={false}
      size="lg"
      show={showWorkModal}
      onHide={() => setShowWorkModal(!showWorkModal)}
      centered
      id="work-maintenance-modal"
      style={{
        background: "#F2F2F2 0% 0% no-repeat padding-box",
        opacity: "0.95",
        marginTop: "0px",
        // zIndex: 10,
      }}
    >
      <div className="maintenance-modal-main-grid-pop">
        <div className="task-modal-left-main" style={{ display: "unset" }}>
          <div className="task-modal-left-top-pop" style={{ width: "535px" }}>
            <div>
              <div className="d-flex">
                <div>
                  <div className="d-flex align-items-center">
                    <img
                      alt=""
                      className="task-icon-pop ms-2"
                      src={Clipboard}
                      style={{
                        display: "inline-block",
                        // minHeight: "39px"
                        // width: "1.318vw",
                        // height: "1.611vw",
                      }}
                    />
                    <p className="margin-0-pop work-modal-text-pop">
                      {/* Work ID  */}
                      {t("Work ID")}-
                    </p>
                    <input
                      type="text"
                      value={workId}
                      style={{
                        border: false ? "1px solid red" : "none",
                        borderRadius: "5px",
                        width: "50%",
                      }}
                      className={"pointerEvent title-text-pop opacity-100"}
                      //   placeholder={"* " + fetchAddTask[18]?.translation}
                      onChange={(e) => {
                        // setTitle(e.target.value);
                        // setChangeComp(e.target.value);
                      }}
                    />
                  </div>
                  <div className="px-4  bolder-text">
                    <input
                      type="text"
                      value={title}
                      // placeholder="*Add a work title"
                      placeholder={`*${t("Add a Work title")}`}
                      name="title"
                      style={{
                        border: false ? "1px solid gray" : "none",
                        borderRadius: "5px",
                        width: "100%",
                        fontWeight: "bolder",
                        color: "gray",
                      }}
                      onChange={(e) => setTitle(e.target.value)}
                      className="task-modal-title-input-pop task-text-bold"
                    />
                  </div>
                </div>
                <div>
                  <h6 className="pb-2 bolder-text color-gray">
                    {/* Type of Maintenance */}
                    {t("Type of Maintenance")}
                  </h6>
                  <Input
                    // placeholder="Select type"
                    placeholder={t("Select Type")}
                    value={typeOfMaintainance?.name}
                    className="select-box"
                    onClick={() => setShowMaintenanceTypeModal(true)}
                  />
                </div>
              </div>
            </div>
            {showMaintenanceTypeModal ? (
              <MaintenanceType
                showModal={showMaintenanceTypeModal}
                setShowModal={setShowMaintenanceTypeModal}
                maintenanceTypeList={typeList}
                setTypeOfMaintenance={setTypeOfMaintenance}
              />
            ) : (
              ""
            )}
            <div
              style={{ position: "relative" }}
              className="mt-5 ps-4"
              // ref={taskSearchRef}
            >
              <Tabs
                type="card"
                defaultActiveKey="general"
                style={{ width: "100%" }}
              >
                {/* <TabPane tab="General" key="general"> */}
                <TabPane tab={t("General")} key="general">
                  <Row>
                    <Col span={24}>
                      <div
                        className="input-container"
                        id="ascInput"
                        ref={asset_Popup_Ref}
                      >
                        <label className="asc-label-top projectNameText">
                          {/* Asset  */}
                          {t("Asset")}
                          <span className="starRed">*</span>
                        </label>

                        <div className="maintenance-input ps-3">
                          <input
                            type="text"
                            placeholder="Select asset"
                            className="clientText"
                            // value={selectedAsset?.assetName}
                            value={assetName}
                            onClick={() => setShowAddGroupPopup(true)}
                          />
                        </div>
                        {showAddGroupPopup && (
                          <div className="client-drop ps-0 py-1">
                            <div className="my-custom-scrollbar">
                              {assetList?.map((item, index) => {
                                return (
                                  <p
                                    className="mb-0 my-custom-para ulterDrop"
                                    key={index}
                                    style={{
                                      textTransform: "capitalize",
                                      backgroundColor: "transparent",
                                    }}
                                    onClick={() => {
                                      setAssetName(item.assetName);
                                      setAssetID(item.assetId);

                                      // setCompany(
                                      //   project.contactdetails[0]
                                      //     .contactclients[0]?.clientname
                                      // );
                                      setShowAddGroupPopup(false);
                                      // setChangeComp(project);
                                    }}
                                  >
                                    {item.assetName}
                                  </p>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col span={24}>
                      <div
                        className="input-container"
                        id="ascInput"
                        ref={client_Popup_Ref}
                      >
                        <label className="asc-label-top projectNameText">
                          {/* Client */}
                          {t("Client")}
                          <span className="starRed">*</span>
                        </label>

                        <div className="maintenance-input ps-3">
                          <input
                            type="text"
                            placeholder="Select client"
                            className="clientText"
                            onClick={() => setShowClientDrop(true)}
                            // onBlur={() => setShowClientDrop(false)}
                            value={clientName}
                          />
                          {showClientDrop && (
                            <div
                              className="client-drop ps-0 py-1"
                              style={{ top: "45px" }}
                            >
                              <p className="my-1 ps-3">Choose a client</p>
                              <div
                                className="client-search-main mx-2"
                                style={{ marginBottom: "10px" }}
                              >
                                <img
                                  alt=""
                                  className="mb-1 search_pop ms-2"
                                  src={searchIcon}
                                />
                                <input
                                  type="text"
                                  // value={clientSearch}
                                  style={{
                                    margin: "0 0 0 0.5rem",
                                    fontSie: "14px",
                                    fontWeight: clientSearch ? "400" : "300",
                                    color: clientSearch ? "" : "#D5D5D5",
                                  }}
                                  value={clientSearch}
                                  placeholder="Search"
                                  className="search-style select-client-div"
                                  onChange={(e) => {
                                    // setChangeComp(e.target.value);
                                    setClientSearch(e.target.value);
                                  }}
                                />
                              </div>
                              <div className="my-custom-scrollbar">
                                {clientList
                                  ?.filter((item) =>
                                    item.clientname
                                      ?.toLowerCase()
                                      .includes(clientSearch.toLowerCase()),
                                  )
                                  .map((item, index) => {
                                    console.log("asc56 client", item);
                                    return (
                                      <p
                                        className="mb-0 my-custom-para ulterDrop"
                                        key={index}
                                        style={{
                                          textTransform: "capitalize",
                                          backgroundColor: "transparent",
                                        }}
                                        onClick={() => {
                                          setClientName(item?.clientname);
                                          setClientID(item?.clientid);
                                          setClientSearch("");
                                          // setCompany(
                                          //   project.contactdetails[0]
                                          //     .contactclients[0]?.clientname
                                          // );
                                          setShowClientDrop(false);
                                          // setChangeComp(project);
                                        }}
                                      >
                                        {item.clientname}
                                      </p>
                                    );
                                  })}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="input-container" id="ascInput">
                        <label className="asc-label-top projectNameText">
                          {/* Facility Location address */}
                          {t("Facility Location Address")}
                        </label>

                        <div className="maintenance-input ps-3">
                          {/* <textarea
                            rows={2}
                            // placeholder={"asset"}
                            className="clientText"
                            name="address"
                            value={maintenanceDetails?.address}
                            onChange={handleChange}
                          /> */}

                          <GooglePlacesAutocomplete
                            // disabled={!isMainAssets}
                            debounce={800}
                            renderInput={(props) => (
                              <textarea
                                style={{
                                  border: "none",
                                  width: "100%",
                                  height: "50px",
                                  overflow: "hidden",
                                }}
                                {...props}
                                rows={4}
                                // placeholder="Address"
                                placeholder={t("Address")}
                              />
                            )}
                            onSelect={(e) => {
                              // handleInputChange("mainAsset", e.description);
                              // handleChange();
                              setSelectedAssetAddress(e.description);
                              // setChangeComp(e.description);
                              handleAddressSelect(e);
                            }}
                            // placeholder="Address"
                            placeholder={t("Address")}
                            // initialValue={maintenanceDetails?.address || ""}
                            initialValue={selectedAssetAddress || ""}
                            withSessionToken={true}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="input-container" id="ascInput">
                        <label className="asc-label-top projectNameText">
                          {/* Work Description */}
                          {t("Work Description")}
                        </label>

                        <div className="maintenance-input ps-3">
                          <textarea
                            rows={4}
                            // placeholder={"asset"}
                            className="clientText"
                            style={{ cursor: "auto" }}
                            name="description"
                            value={description}
                            onChange={(e) => {
                              setDescription(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </TabPane>
                {/* <TabPane tab="Checklist" key="checklist"> */}
                <TabPane tab={t("Checklist")} key="checklist">
                  {/* checklist form fields */}
                  {/* Checklist */}
                  <div
                  // style={{height: "6vh" }}
                  >
                    <div className="dep-link-flex-pop d-none">
                      <p>
                        <Button
                          onClick={() => setShowCheckList(true)}
                          type="text"
                          icon={
                            <PlusCircleFilled style={{ color: "#95a7c6" }} />
                          }
                        >
                          {/* Add a checklist */}
                          {t("Add Checklist")}
                        </Button>
                      </p>
                    </div>
                    {checklist?.length > 0 && (
                      <div className="work-modal-line-pop">
                        <Wrapper2
                          className="task-modal-line-color"
                          style={{
                            backgroundColor: "#00246a",
                            width: `${percent}%`,
                          }}
                        ></Wrapper2>
                        {percent > 0 ? (
                          <div
                            className="text-end"
                            style={{
                              width: `${percent}%`,
                              fontSize: "12px",
                              color: "#333333",
                            }}
                          >
                            {Math.floor(percent)}%
                          </div>
                        ) : (
                          <div
                            className=""
                            style={{ fontSize: "12px", color: "#333333" }}
                          >
                            {0}%
                          </div>
                        )}
                      </div>
                    )}
                    {checklist?.length > 0 && (
                      <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable
                          droppableId={dropId}
                          key={`droppable-${dropId}`}
                        >
                          {(provided) => (
                            <div
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                              key={`droppable-div-${dropId}`}
                            >
                              {checklist.map((item, index) => (
                                <Draggable
                                  key={`draggable-${item?.checklistid}`}
                                  draggableId={item?.checklistid}
                                  index={index}
                                >
                                  {(provided) => (
                                    <div
                                      key={index}
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      className="checklist-item-grid"
                                    >
                                      <div>
                                        <div
                                          className={"checklist-dot-pop"}
                                          style={{
                                            backgroundColor: item.isCompleted
                                              ? "#00246a"
                                              : "transparent",
                                            border: item.isCompleted
                                              ? "none"
                                              : "0.5px #707070 solid",
                                            borderRadius: "5px",
                                          }}
                                          onClick={() => {
                                            if (item.isCompleted) {
                                              markCheckListCompleted(
                                                index,
                                                false,
                                              );
                                            } else {
                                              markCheckListCompleted(
                                                index,
                                                true,
                                              );
                                              // let main = [...checklist];
                                              // main[index].ischecklist = 1;
                                              // setChecklist(main);
                                              // setTotalCheck(main.length);
                                            }
                                          }}
                                        ></div>
                                      </div>
                                      <p
                                        className="margin-0-pop task-text-bold"
                                        style={{
                                          textAlign: "start",
                                          fontWeight: "500",
                                          fontSize: "16px",
                                          color: "#373535ff",
                                        }}
                                      >
                                        {item.name}
                                      </p>
                                      <div style={{ textAlign: "" }}>
                                        <img
                                          className={true ? "" : ""}
                                          alt=""
                                          src={deleteIcon}
                                          style={{
                                            opacity: "50%",
                                            height: "15px",
                                            width: "15px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            handleDeleteCheckList(index);
                                          }}
                                        />
                                      </div>
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    )}
                    {showAddChecklist && (
                      <div className="checklist-item-grid pt-2">
                        <div></div>
                        <input
                          className="margin-0-pop"
                          style={{
                            textAlign: "start",
                            fontWeight: "500",
                            fontSize: "14px",
                            border: "none",
                            width: "100%",
                          }}
                          value={itemName}
                          // placeholder={"Add Item"}
                          placeholder={t("Add Item")}
                          onChange={(e) => setItemName(e.target.value)}
                          //   onChange={(e) => {
                          //     setChangeComp(e.target.value);
                          //     setChecklistTitle(e.target.value);
                          //   }}
                        />
                        <div style={{ textAlign: "" }}>
                          <img
                            alt=""
                            src={
                              // companyId == "28830f30-b321-4662-a576-f23451677733"
                              //   ? PlusCBD
                              //   : companyId == "28830f30-b321-4662-a576-f23451677744"
                              //     ? PlusZUID
                              //     : Plus32
                              PlusIcon
                            }
                            style={{
                              width: "16px",
                              height: "16px",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              handleAddChecklist({
                                name: itemName,
                                isCompleted: false,
                              })
                            }
                          />
                        </div>
                      </div>
                    )}
                    {checklist?.length > 0 && !showAddChecklist ? (
                      <div
                        // className="checklist-item-grid-add"
                        className={false ? "d-none" : "checklist-item-grid-add"}
                        onClick={() => setShowCheckList(!showAddChecklist)}
                      >
                        <div
                          className="checklist-AddItem"
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                          }}
                        >
                          {" "}
                          {/* Add Item */}
                          {t("Add Item")}
                          {/* {fetchAddTask[16]?.translation} */}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </TabPane>
                {/* <TabPane tab="Purchasing" key="purchasing"> */}
                <TabPane tab={t("Purchasing")} key="purchasing">
                  {/* Purchasing form fields */}
                  <div>
                    <div className="dep-link-flex-pop d-none">
                      <p>
                        <Button
                          onClick={() => setShowCheckList(true)}
                          type="text"
                          icon={
                            <PlusCircleFilled style={{ color: "#95a7c6" }} />
                          }
                        >
                          {/* Add a New PO */}
                          {t("Add a New PO")}
                        </Button>
                      </p>
                    </div>
                    <div>
                      {POData.map((item, index) => {
                        return (
                          <div>
                            <p>{item.nameee}</p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </TabPane>
              </Tabs>
            </div>

            {/* comment */}
            <div className="margin-left-main-pop">
              <p
                className="mb-0 ms-16-bold-left-pop"
                style={{ fontSize: "13px", color: "green" }}
              >
                {attachMessage}
              </p>
              <div
                className=" dep-link-flex-pop align-items-end"
                style={{ margin: "0", height: "30px" }}
              >
                <p className="margin-0-pop ms-16-bold-left-pop">
                  {/* Comment */}
                  {t("Comment")}
                </p>

                {(newAddedComments?.length > 4 ||
                  maintenance?.comments?.length > 4) && (
                  <p
                    className="margin-0-pop ms-16-bold-left-pop pointer"
                    onClick={() => {
                      setShowMoreComm(!showMoreComm);
                    }}
                  >
                    {showMoreComm ? " Show less..." : "Show more..."}
                  </p>
                )}
              </div>
            </div>

            <div
              // className="row commentarea"
              className={
                type === "add"
                  ? "row commentarea pointerNone"
                  : "row commentarea"
              }
            >
              <div className="px-0 my-1 col-1 d-flex">
                <button
                  className="teambtn comment-abbre-pop"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{
                    marginTop: "10px",
                    textTransform: "uppercase",
                    fontSize: "clamp(16px, .833vw, .833vw)",
                    width: " clamp(37px, 1.927vw, 1.927vw)",
                    height: "clamp(37px, 1.927vw, 1.927vw)",
                    borderRadius: "50%",
                    border: "none",
                  }}
                >
                  {userlastname
                    ? userfirstname[0]?.toUpperCase() +
                      "" +
                      userlastname[0]?.toUpperCase()
                    : userfirstname?.slice(0, 2).toUpperCase()}
                </button>
              </div>

              <div
                className="p-0 col-11"
                id="addTaskComntBox"
                style={{ height: "155px", minHeight: "150px" }}
              >
                <Editor
                  id="maintEditor"
                  // placeholder={"write a comment"}
                  placeholder={t("Write a comment")}
                  editorState={editorState}
                  onEditorStateChange={changeApplied}
                  handlePastedText={handleCommentPastedText}
                  wrapperClassName="wrapper-class ms-1"
                  editorClassName="task-comment-text-pop text-black"
                  toolbarClassName="toolbar-bottom-absolute"
                  toolbarHidden={true}
                  mention={{
                    separator: " ",
                    trigger: "@",
                    suggestions: activeUsers.map((x) => ({
                      text: `${x.firstname} ${x.lastname}`,
                      value: `${x.firstname} ${x.lastname}`,
                      url: x.userid,
                    })),
                  }}
                />
                {/* {
                  <div
                    className="drop-down-plus-pop at_the_rate"
                    id="drop-down-plus"
                  >
                    <div className="search-div-people">
                      <FiSearch
                        style={{
                          marginRight: "6px",
                          marginBottom: "3px",
                        }}
                      />
                      <input
                        type="text"
                        style={
                          searchPeople
                            ? { opacity: "100%" }
                            : { opacity: "50%" }
                        }
                        className="search-people-input"
                        placeholder={"search"}
                        value={searchPeople}
                        onChange={(e) => {
                          //   setChangeComp(e.target.value);
                          setSearchPeople(e.target.value);
                        }}
                      />
                    </div>
                    {activeUsers?.map((people, index) => {
                      return (
                        <div
                          key={index}
                          className="peoples-flex"
                          onClick={() => {
                            selectedUser(people);
                          }}
                        >
                          <p style={{ marginBottom: "0" }}>
                            {people?.firstname} {people?.lastname}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                } */}

                <div
                  role={"button"}
                  className=" position-relative"
                  style={{ left: "75%", bottom: "25%" }}
                >
                  <p className="mb-0">
                    <span
                      className="ps-1 ms-xxl-2"
                      style={{
                        display: "grid",
                        alignItems: "center",
                        gridTemplateColumns: "1fr 1fr 16fr",
                        position: "relative",

                        // right: "17px",
                      }}
                    >
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          marginRight: "5px",
                        }}
                      >
                        <img
                          alt="emoji"
                          src={Icon2}
                          style={{
                            cursor: "pointer",
                            width: "18px",
                            height: "18px",
                            marginBottom: "3px",
                          }}
                          onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                        />
                        {showEmojiPicker && (
                          <div
                            ref={emojiPickerRef}
                            className="emoji-picker-style"
                            style={{ left: "-256px" }}
                          >
                            <Picker
                              data={data}
                              onEmojiSelect={(e) => {
                                const contentState = Modifier.replaceText(
                                  editorState.getCurrentContent(),
                                  editorState.getSelection(),
                                  e.native,
                                  editorState.getCurrentInlineStyle(),
                                );
                                setShowEmojiPicker(!showEmojiPicker);
                                setEditorState(
                                  EditorState.push(
                                    editorState,
                                    contentState,
                                    "insert-characters",
                                  ),
                                );
                              }}
                            />
                          </div>
                        )}
                      </div>
                      <DocumentUploaderWithProgress
                        onUploaded={(data) => {
                          const name = data?.map((item) => item?.name);
                          const size = data?.map((item) => item?.size);
                          const link = data?.map((item) => item?.link);
                          // setUploadedFileName(data.name);
                          setUploadedFileName(name.join(", "));
                          setImgUrl(link);
                          setChangeComp(data);
                        }}
                      >
                        <label>
                          <i
                            className="bi bi-paperclip attach-icon-pop"
                            style={{ color: "#bfbfbf" }}
                          ></i>
                        </label>
                      </DocumentUploaderWithProgress>

                      <img
                        style={{
                          width: "18px",
                          height: "18px",
                          marginBottom: "3px",
                          opacity: "0.5",
                        }}
                        src={send}
                        className="mx-"
                        alt="leftarrow"
                        onClick={() => {
                          const content = editorState
                            .getCurrentContent()
                            .getPlainText();
                          if (content === "" && !imgUrl) return; // if comment empty.

                          // if (props.val.length > 0 ? "arrowEvent" : "") {
                          //   let trimText = props.val.trim();
                          //   if (trimText !== "") {
                          //     if (props.modalFunction === "update") {
                          handleAddComments();
                          setEditorState(() => EditorState.createEmpty());
                          handleFinalAddComments();
                          // } else {
                          // let attachments = props.imgUrl;
                          // let message = props.val;
                          // let timestamp = new Date().toISOString();
                          // props.setShow([
                          //   ...props.show,
                          //   {
                          //     attachments,
                          //     message,
                          //     timestamp,
                          //     taggedUser: props.taggedUser,
                          //   },
                          // ]);
                          // props.setLength(props.show.length);
                          // props.setMaxComments([
                          //   ...props.maxComments,
                          //   {
                          //     attachments,
                          //     message,
                          //     timestamp,
                          //     taggedUser: props.taggedUser,
                          //   },
                          // ]);

                          setMessage("");
                          setUploadedFileName("");
                          setImgUrl("");
                          // props.setVal("");
                          // props.setImgUrl("");
                          setEditorState(() => EditorState.createEmpty());
                        }}
                      />
                    </span>
                  </p>
                </div>
              </div>
              <div className="px-0 my-1 col-1 d-flex"></div>
              <div className="col-11 uploadedFileName">{uploadedFileName}</div>
            </div>

            {/* <div style={{}}>
              {maintenance?.comments?.slice(0, 5).map((item, index) => (
                <div
                  key={index}
                  className="my-2 row"
                  style={{ marginBottom: "2rem" }}
                >
                  <div className="px-0 my-1 col-1 pe-1 d-flex">
                    <button
                      className="teambtn"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{
                        // minWidth: "37px",
                        textTransform: "uppercase",
                        // fontSize: "var(--responsive-font-16)",
                        fontSize: "clamp(16px, .833vw, .833vw)",
                        // width: "3vw",
                        // height: "3vw",
                        width: "clamp(37px, 1.927vw, 1.927vw)",
                        height: "clamp(37px, 1.927vw, 1.927vw)",
                        borderRadius: "50%",
                        border: "none",
                      }}
                    >
                      {userlastname
                        ? userfirstname[0]?.toUpperCase() +
                          "" +
                          userlastname[0]?.toUpperCase()
                        : userfirstname.slice(0, 2).toUpperCase()}
                    </button>
                  </div>
                  <div
                    className="col-11 comment-box ms-1"
                    style={{
                      borderRadius: "10px",
                      border: "1px rgb(133, 133, 133) solid",
                      width: "clamp(504px, 25.781vw, 25.781vw)",
                      // marginLeft: "12px",
                    }}
                  >
                    <div className="row">
                      <div className="pt-2 col-8 fntMessage text-start position-relative d-inline">
                        {item.attachments === null ? (
                          ""
                        ) : (
                          <span
                            id="comment_attach"
                            style={{
                              fontSize: "clamp(14px, .729vw, .729vw)",
                              color: "#333333",
                            }}
                          >
                            {isJson(item.message) ? (
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: getFormattedMessage(item.message),
                                }}
                              ></span>
                            ) : (
                              item.message
                            )}
                            &nbsp;
                            <a
                              href={item.attachments}
                              target="_blank"
                              className=" image-link"
                              rel="noreferrer"
                            >
                              <span className="fw-bold taskclr">
                                {/* {item.attachments.split(".com/")[1]} */}
            {/* </span>
                            </a>
                          </span>
                        )}
                      </div>
                      <div className="mt-2 col-4 text-end dateTime fntdate">
                        <div
                          className="row pe-1 ms-2"
                          style={{
                            marginBottom: "4px",
                            marginTop: "30px",
                            fontSize: "clamp(14px, .729vw, .729vw)",
                          }}
                        >
                          {moment(item.timestamp).format("DD.MM.YYYY") + " "} */}
            {/* {new Date(item.timestamp).toString().split(" ")[2] +
                                                                    "." +
                                                                    new Date(item.timestamp).toString().split(" ")[1] +
                                                                    "." +
                                                                    new Date(item.timestamp).toString().split(" ")[3] +
                                                                    " "} */}
            {/* {item.timestamp.split("T")[ 1 ].split(":")[ 0 ] +
                                                                    ":" +
                                                                    item.timestamp.split("T")[ 1 ].split(":")[ 1 ] +
                                                                    "H"} */}
            {/* {getLocalFormatedTime(item.timestamp) + "H"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div> */}

            {/* asc add comments start. */}
            <div>
              {newAddedComments
                ?.slice(0, displayQuantity)
                .map((item, index) => {
                  console.log("asc43", item);
                  return (
                    <div
                      key={index}
                      className="row commentarea"
                      style={{ marginBottom: "0.5rem" }}
                    >
                      <div className="px-0 my-1 col-1 pe-1 d-flex">
                        <button
                          style={{
                            border: "none",
                            borderRadius: "50%",
                            fontSize: "clamp(16px, .833vw, .833vw)",
                          }}
                          className="teambtn"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {userlastname
                            ? userfirstname[0]?.toUpperCase() +
                              "" +
                              userlastname[0]?.toUpperCase()
                            : userfirstname.slice(0, 2).toUpperCase()}
                        </button>
                      </div>

                      <div
                        className="col-11 comment-box ms-1"
                        style={{
                          borderRadius: "10px",
                          border: "1px rgb(133, 133, 133) solid",
                          width: "89%",
                          height: "auto",
                        }}
                      >
                        <div className="row">
                          <div className="py-2 col-11 fntMessage text-start position-relative d-inline flex-grow-1">
                            {item.attachments === null ? (
                              ""
                            ) : (
                              <span
                                id="comment_attach"
                                style={{
                                  fontSize: "clamp(14px, .729vw, .729vw)",
                                  color: "#333333",
                                  height: "auto",
                                }}
                              >
                                {isJson(item.addedComments) ? (
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: getFormattedMessage(
                                        item.addedComments,
                                      ),
                                    }}
                                  ></span>
                                ) : (
                                  item.addedComments
                                )}
                                &nbsp;
                                {!item?.isdeleted &&
                                  item?.attachURL &&
                                  Array.isArray(item?.attachURL) && (
                                    <a
                                      href={item?.attachURL}
                                      target="_blank"
                                      className=" image-link"
                                      rel="noreferrer"
                                    >
                                      <span className="fw-bold taskclr">
                                        {/* {item.attachURL?.split(".com/")[1]} */}
                                        {item.attachURL.map((x, index) => (
                                          <a
                                            key={index}
                                            href={x}
                                            target="_blank"
                                            className="image-link"
                                            rel="noreferrer"
                                            style={{}}
                                          >
                                            <div className="blueTxt">
                                              {/* {x.split(".com/")[1]} */}
                                              {x.split("/").pop()}
                                            </div>
                                          </a>
                                        ))}
                                      </span>
                                    </a>
                                  )}
                              </span>
                            )}
                          </div>
                          <div className="mt-2 col-4 text-end dateTime fntdate ms-auto">
                            <div
                              className="row pe-1 ms-2"
                              style={{
                                marginBottom: "4px",
                                marginTop: "30px",
                                fontSize: "clamp(14px, .729vw, .729vw)",
                              }}
                            >
                              {moment(item.createdAt).format("DD.MM.YYYY")}
                              {/* {new Date(item.timestamp).toString().split(" ")[2] +
                            "." +
                            new Date(item.timestamp).toString().split(" ")[1] +
                            "." +
                            new Date(item.timestamp).toString().split(" ")[3] +
                            " "}
                          {item.timestamp.split("T")[1].split(":")[0] +
                            ":" +
                            item.timestamp.split("T")[1].split(":")[1] +
                            "H"} */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            {/* asc add comments end. */}

            {type === "update" && (
              <div>
                {maintenance?.comments
                  ?.slice(0, displayQuantity)
                  .map((item, index) => (
                    <div
                      key={index}
                      className="row commentarea"
                      style={{ marginBottom: "0.5rem" }}
                    >
                      <div className="px-0 my-1 col-1 pe-1 d-flex">
                        <button
                          style={{
                            border: "none",
                            borderRadius: "50%",
                            fontSize: "clamp(16px, .833vw, .833vw)",
                          }}
                          className="teambtn"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {userlastname
                            ? userfirstname[0]?.toUpperCase() +
                              "" +
                              userlastname[0]?.toUpperCase()
                            : userfirstname.slice(0, 2).toUpperCase()}
                        </button>
                      </div>

                      <div
                        className="col-11 comment-box ms-1"
                        style={{
                          borderRadius: "10px",
                          border: "1px rgb(133, 133, 133) solid",
                          width: "89%",
                          height: "auto",
                        }}
                      >
                        <div className="row">
                          <div className="py-2 col-11 fntMessage text-start position-relative d-inline flex-gow-1">
                            {item.attachments === null ? (
                              ""
                            ) : (
                              <span
                                id="comment_attach"
                                style={{
                                  fontSize: "clamp(14px, .729vw, .729vw)",
                                  color: "#333333",
                                }}
                              >
                                {isJson(item.comment) ? (
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: getFormattedMessage(item.comment),
                                    }}
                                  ></span>
                                ) : (
                                  item.comment
                                )}
                                &nbsp;
                                <a
                                  href={JSON.parse(item?.attachments)} // from api
                                  target="_blank"
                                  className=" image-link"
                                  rel="noreferrer"
                                >
                                  <span className="taskclr blueTxt">
                                    {!item?.isdeleted &&
                                      item?.attachments &&
                                      Array.isArray(
                                        JSON.parse(item?.attachments),
                                      ) && (
                                        <div
                                          style={{
                                            lineHeight: "2",
                                            marginTop: "-25px",
                                          }}
                                        >
                                          {JSON.parse(item.attachments).map(
                                            (x, index) => (
                                              <a
                                                key={index}
                                                href={x}
                                                target="_blank"
                                                className="image-link"
                                                rel="noreferrer"
                                                style={{}}
                                              >
                                                <div className="blueTxt">
                                                  {/* {x.split(".com/")[1]} */}
                                                  {x.split("/").pop()}
                                                </div>
                                              </a>
                                            ),
                                          )}
                                        </div>
                                      )}
                                  </span>
                                </a>
                              </span>
                              // <span>
                              //   {item.message}&nbsp;
                              //   <a
                              //     href={item.attachments}
                              //     target="_blank"
                              //     className=" image-link"
                              //   >
                              //     <span className="fw-bold taskclr">
                              //       {item.attachments.split(".com/")[ 1 ]}
                              //     </span>
                              //   </a>
                              // </span>
                            )}
                          </div>
                          <div className="mt-2 col-4 text-end dateTime fntdate ms-auto">
                            <div
                              className="row pe-1 ms-2"
                              style={{
                                marginBottom: "4px",
                                marginTop: "30px",
                                fontSize: "clamp(14px, .729vw, .729vw)",
                              }}
                            >
                              {moment(item.createdAt).format("DD.MM.YYYY")}
                              {/* {new Date(item.timestamp).toString().split(" ")[2] +
                            "." +
                            new Date(item.timestamp).toString().split(" ")[1] +
                            "." +
                            new Date(item.timestamp).toString().split(" ")[3] +
                            " "}
                          {item.timestamp.split("T")[1].split(":")[0] +
                            ":" +
                            item.timestamp.split("T")[1].split(":")[1] +
                            "H"} */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            )}
          </div>
          <div className="" style={{ display: "contents" }}>
            <div
              className="mb-4 d-flex me-5 justify-content-end"
              style={{ backgroundColor: "#FFFFF" }}
            >
              <Button
                type="default"
                style={{
                  color: "#00246A",
                  border: "1px solid #00246A",
                  borderRadius: "12px",
                  width: "132px",
                  height: "42px",
                  fontSize: "14px",
                  display: "flex",
                  fontWeight: "700",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => setShowWorkModal(false)}
              >
                {/* Cancel */}
                {t("Cancel")}
              </Button>
              {roleAccess !== ROLES.VIEWER && roleAccess !== ROLES.USER && (
                <Button
                  disabled={
                    !title ||
                    !assetName ||
                    // !selectedAsset?.assetName ||
                    !clientName ||
                    !startDate
                  }
                  type="primary"
                  className="ms-4"
                  style={{
                    marginLeft: "12px",
                    backgroundColor: "#00246A",
                    color: "white",
                    borderRadius: "12px",
                    width: "132px",
                    height: "42px",
                    fontSize: "14px",
                    display: "flex",
                    fontWeight: "700",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={handleSubmit}
                >
                  {/* {type === "update" ? "Change" : "Add"} */}
                  {type === "update" ? t("Change") : t("Add")}
                </Button>
              )}
            </div>

            {/* <div
            className="gap-color"
            style={{
              backgroundColor: "#e9e9e9",
              width: "clamp(272px, 12.552vw, 12.552vw)",
            }}
          ></div> */}
          </div>
        </div>
        <div
          className="task-modal-right-main-pop"
          style={{
            width: "clamp(272px, 12.552vw, 12.552vw)",
          }}
        >
          <div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              {/* <img className="task-card-calendar-pop" src={Calender} /> */}
              <p
                className="margin-0-pop ms-16-bold-right-pop ms-4 ps-1"
                style={{ marginTop: "0px", marginLeft: "10px" }}
              >
                {/* Start Date */}
                {t("Start Date")}
                <span className="starRed">*</span>
              </p>
            </div>
            <label
              id="contact_calender"
              className={
                false === process.env.REACT_APP_IS_VIEWER ? "pointerEvent" : ""
              }
              style={{
                display: "flex",
                width: "94%",
                color: "#333333",
                // border: !startDate && "0.5px solid red",
                // borderRadius: !startDate && "6px",
              }}
            >
              <img
                // className="task-card-calendar-pop"
                className={
                  false === process.env.REACT_APP_IS_VIEWER
                    ? "pointerEvent task-card-calendar-pop"
                    : "task-card-calendar-pop"
                }
                style={{
                  position: "relative",
                  bottom: "23px",
                }}
                src={Calender}
                alt=""
                onClick={() => setCalendarStartDateIsOpen(true)}
              />

              <AppDatePicker
                // open={calendarStartDateIsOpen}
                selected={startDate}
                onChange={(val) => {
                  setStartDate(val);
                  setCalendarStartDateIsOpen(false);
                }}
                onSelect={(d, event) => {
                  // setDateError(false);
                  event.preventDefault();
                }}
                // isError={dateError}
                // error={setDateError}
                placeholderText={"00/00/0000"}
                dateFormat="dd/MM/yyyy"
                className={"ps-3"}
              />
            </label>
          </div>
          <div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <img className="task-card-calendar-pop" src={Clock} alt="" />
              <p
                className="margin-0-pop ms-16-bold-right-pop "
                style={{ marginTop: "0px", marginLeft: "10px" }}
              >
                {/* Start Time */}
                {t("Start Time")}
              </p>
            </div>
            <div
              className={
                false === process.env.REACT_APP_IS_VIEWER
                  ? "pointerEvent due-time-text-pop"
                  : "due-time-text-pop"
              }
            >
              <input
                type="number"
                placeholder="08"
                id="hoursInput"
                style={{
                  width: "23px",
                  background: "transparent",
                  border: "none",
                  fontSize: "var(--responsive-font-16)",
                  "-moz-appearance": "textfield",
                }}
                value={hours}
                maxLength="2"
                onKeyDown={handleHoursKeyDown}
                onChange={handleHoursChange}
              />
              <span
                style={{
                  fontSize: "var(--responsive-font-16)",
                }}
              >
                :
              </span>
              <input
                placeholder="00"
                type="number"
                id="minutesInput"
                maxLength="2"
                style={{
                  width: "23px",
                  background: "transparent",
                  border: "none",
                  fontSize: "var(--responsive-font-16)",
                  "-moz-appearance": "textfield",
                }}
                value={minutes}
                onKeyDown={handleMinutesKeyDown}
                onChange={handleMinutesChange}
              />
              {/* <span style={{ fontSize: "var(--responsive-font-16)" }}>H</span> */}
            </div>
          </div>

          {/* status */}
          <div className="pt- pt-xxl-">
            <div style={{ display: "flex", flexDirection: "row" }}>
              <img
                alt=""
                src={statusicon}
                style={{
                  width: "clamp(22px, 1.146vw, 1.146vw)",
                  height: "clamp(22px, 1.146vw, 1.146vw)",
                }}
              />
              <p
                className="margin-0-pop ms-16-bold-right-pop"
                style={{ marginTop: "0px", marginLeft: "7px" }}
              >
                {/* Status */}
                {t("Status")}
              </p>
            </div>

            <div
              style={{ marginLeft: "30px", paddingRight: "19px" }}
              //   ref={statusDropdownRef}
            >
              <div
                style={{
                  cursor: "pointer",
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  onClick={() => setShowStatusDrop(!showStatusDrop)}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <p className="margin-0-pop status-text-pop">{statusName}</p>
                  <BsChevronDown
                    style={{
                      marginTop: "4px",
                      fontSize: "1.2rem",
                      // height: "9px", width: "16px",
                    }}
                    className={`${
                      showStatusDrop
                        ? "down-arrow-pop down-arrow-rotate bi-paperclip"
                        : "down-arrow-pop bi-paperclip"
                    }`}
                  />
                </div>
                {showStatusDrop && (
                  <div
                    className="drop-down-noti drop_down_layout"
                    style={{
                      width: "clamp(186px, 7.604vw, 7.604vw) ",
                      height: "clamp(98px, 5.104vw, 5.104vw)",
                    }}
                  >
                    {statusData?.map((item, i) => {
                      return (
                        <p
                          key={i}
                          className="margin-0-pop mapped-notification"
                          style={{
                            opacity: item.name === statusName ? "1" : "70%",
                            fontSize: "clamp(14px, 0.833vw, 0.833vw)",
                            background:
                              statusName === item.name ? "#f0f0f0" : "",
                          }}
                          onClick={() => {
                            setStatusId(item.statusId);
                            setStatusName(item.statusName);
                            setShowStatusDrop(false);
                            // setChangeComp(item.id);
                          }}
                        >
                          {item.statusName}
                        </p>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* assignee */}
          <div
            className="pt-3"
            //   ref={assigneeDropdownRef}
          >
            <div
              style={{ display: "flex", flexDirection: "row" }}
              onClick={() => {
                setShowDropPeople(false);
                setSearchPeople("");
              }}
            >
              <img className="task-card-calendar1" src={user} alt="" />
              <p
                className="margin-0-pop ms-16-bold-right-pop"
                style={{ marginTop: "0px", marginLeft: "11px" }}
              >
                {t("Assigne To")}
                {/* Assigne To */}
              </p>
            </div>

            <div
              className={
                false === process.env.REACT_APP_IS_VIEWER ? "pointerEvent" : ""
              }
            >
              <div className="mt-2 me-2 assign_to_plus_pop">
                {assignee?.map((item, index) => {
                  return (
                    <div key={index}>
                      {item.imageurl ? (
                        <img
                          src={item?.imageurl}
                          className="orderIcon"
                          style={{
                            width: "clamp(56px, 2.917vw, 2.917vw)",
                            height: "clamp(56px, 2.917vw, 2.917vw)",
                            cursor: "pointer",
                            borderRadius: "100%",
                            marginLeft: "-25px",
                            border: "0.2vw #ffffff solid ",
                            objectFit: "cover",
                          }}
                          alt=""
                          onClick={() => {
                            setShowDropPeople(!showDropPeople);
                            setSearchPeople("");
                          }}
                        />
                      ) : (
                        <div className="abbre-pop">
                          {item?.lastname
                            ? item?.firstname[0]?.toUpperCase() +
                              "" +
                              item?.lastname[0]?.toUpperCase()
                            : item?.firstname?.slice(0, 2).toUpperCase()}
                        </div>
                      )}
                    </div>
                  );
                })}
                <div
                  className="plus-design-pop"
                  onClick={() => {
                    setShowDropPeople(!showDropPeople);
                    setSearchPeople("");
                  }}
                >
                  <BsPlusLg
                    style={{
                      color: "#00246A",
                      fontSize: "clamp(2rem,2vw,2.5vw)",
                    }}
                  />
                </div>
                {showDropPeople && (
                  <div
                    className="drop-down-plus-pop"
                    id="drop-down-plus"
                    style={{ zIndex: "1", left: "-20%" }}
                  >
                    <div className="search-div-people">
                      <FiSearch
                        style={{
                          marginRight: "6px",
                          marginBottom: "3px",
                        }}
                      />
                      <input
                        type="text"
                        style={
                          searchPeople
                            ? { opacity: "100%" }
                            : { opacity: "50%" }
                        }
                        className="search-people-input"
                        // placeholder={"Search"}
                        placeholder={t("Search")}
                        value={searchPeople}
                        onChange={(e) => {
                          //   setChangeComp(e.target.value);
                          setSearchPeople(e.target.value);
                        }}
                      />
                    </div>

                    {activeUsers?.map((people, index) => {
                      const isUserAssigned = assignee.some(
                        (item) => item.assigneeid === people.userid,
                      );
                      return (
                        <div
                          key={index}
                          className={`peoples-flex ${
                            isUserAssigned
                              ? "selectedAssignee"
                              : "non-selectedAssignee"
                          }`}
                          onClick={() => {
                            setAssignee([...assignee, people.userid]);
                            setShowDropPeople(false);
                            // setChangeComp(people.userid);
                            if (
                              assignee?.find((item) => {
                                if (item.assigneeid === people.userid) {
                                  return true;
                                } else {
                                  return false;
                                }
                              })
                            ) {
                              let data = [...assignee];
                              data = data.filter((item) => {
                                return item.assigneeid !== people.userid;
                              });
                              setAssignee(data);
                              // setShowDropPeople(false);
                              // setSelectedAssignee([]);
                            } else {
                              const assigneeid = people.userid;
                              const imageurl = people.imageurl;

                              const firstname = people.firstname;
                              const lastname = people.lastname;
                              setAssignee([
                                ...assignee,
                                {
                                  assigneeid,
                                  imageurl,
                                  firstname,
                                  lastname,
                                },
                              ]);
                              setShowDropPeople(false);
                              // setSelectedAssignee([
                              //   ...selectedAssignee,
                              //   people.userid,
                              // ]);
                            }
                          }}
                        >
                          {people.imageurl ? (
                            <img
                              alt=""
                              src={people.imageurl}
                              style={{
                                width: "clamp(50px, 2.604vw, 2.604vw)",
                                height: "clamp(50px, 2.604vw, 2.604vw)",
                                borderRadius: "100%",
                                border: "2px solid var(--unnamed-color-00246a)",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                backgroundColor: "#95A7C6",
                                color: "#ffffff",
                                width: "clamp(50px, 2.604vw, 2.604vw)",
                                height: "clamp(50px, 2.604vw, 2.604vw)",
                                borderRadius: "100%",
                                border: "2px solid var(--unnamed-color-00246a)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              {people?.lastname
                                ? people?.firstname[0]?.toUpperCase() +
                                  "" +
                                  people?.lastname[0]?.toUpperCase()
                                : people?.firstname?.slice(0, 2).toUpperCase()}
                            </div>
                          )}

                          <p
                            style={{
                              marginBottom: "0",
                              textAlign: "start",
                              gap: "8px",
                            }}
                            className="assign-user"
                          >
                            {people?.firstname} {people?.lastname}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>

          {fetchAppSideNavOptions &&
            Array.isArray(fetchAppSideNavOptions) &&
            fetchAppSideNavOptions.every(
              (item) => item.packageName !== "Basic",
            ) && (
              <div>
                <div className="displayFlexCss">
                  <img
                    className=""
                    src={Timer}
                    alt=""
                    style={{
                      width: "18px",
                      height: "20px",
                    }}
                  />
                  <p
                    className="margin-0 ms-16-bold"
                    style={{ marginTop: "0px", marginLeft: "7px" }}
                  >
                    Track Time
                    {/* {fetchTransUpdateTaskList[45]?.translation} */}
                  </p>
                </div>
                <div className="time-track-flex d-block pe-5">
                  <div className="time-track-left-session">
                    <p className="time-track-csession-text">
                      Current Session
                      {/* {fetchTransUpdateTaskList[46]?.translation} */}
                    </p>
                    <div
                      className="due-time-text-pop"
                      style={{ marginLeft: "0" }}
                    >
                      <p
                        style={{
                          width: "23px",
                          background: "transparent",
                          border: "none",
                          fontSize: "16px",
                        }}
                      >
                        {isTimerRunning ? session1 : "00"}
                      </p>
                      <span
                        style={{
                          fontSize: "16px",
                        }}
                      >
                        :
                      </span>
                      <p
                        style={{
                          width: "23px",
                          background: "transparent",
                          border: "none",
                          fontSize: "16px",
                        }}
                      >
                        {isTimerRunning ? session2 : "00"}
                      </p>
                      <span
                        style={{
                          fontSize: "16px",
                        }}
                      >
                        :
                      </span>
                      <p
                        style={{
                          width: "23px",
                          background: "transparent",
                          border: "none",
                          fontSize: "16px",
                        }}
                      >
                        {isTimerRunning ? session3 : "00"}
                      </p>
                    </div>
                  </div>
                  <article className="time-track-left-session">
                    <p className="time-track-csession-text">
                      Total
                      {/* {fetchTransUpdateTaskList[60]?.translation} */}
                    </p>
                    <div
                      className="due-time-text-pop"
                      style={{ marginLeft: "0" }}
                    >
                      <p
                        style={{
                          // width: "23px",
                          width: "auto",
                          background: "transparent",
                          border: "none",
                          fontSize: "16px",
                        }}
                      >
                        {total1}
                      </p>
                      <span
                        style={{
                          fontSize: "16px",
                        }}
                      >
                        :
                      </span>
                      <p
                        style={{
                          // width: "23px",
                          width: "auto",
                          background: "transparent",
                          border: "none",
                          fontSize: "16px",
                        }}
                      >
                        {total2}
                      </p>
                    </div>
                  </article>
                </div>
                <div
                  className="track-time-box"
                  onClick={() => {
                    if (disableTracking) return;
                    if (isTimerRunning) {
                      setChangeComp("changed");
                      localStorage.removeItem("timerForAssetType");
                      return dispatch(
                        UpdateTimeSession(
                          taskTrackingId,
                          moment().format("DD/MM/YYYY"),
                          moment().format("HH:mm:ss"),
                        ),
                      );
                    }
                    if (!maintainaceId) {
                      return handleGeneralNotification({
                        notificationType: "CUSTOM",
                        text: `Please add a work maintenance first`,
                      });
                    }
                    setChangeComp(true);
                    dispatch(
                      CheckIfTimeSessionStartOrNot(
                        "00000000-0000-0000-0000-000000000000",
                        maintainaceId,
                        window.localStorage.getItem("userid"),
                        moment().format("DD/MM/YYYY"),
                        moment().format("HH:mm:ss"),
                      ),
                    );
                    localStorage.setItem(
                      "timerForAssetType",
                      JSON.parse(currentAsset).assetType ===
                        "5a8e302f-feef-435a-a57d-803af7590701"
                        ? "/asset-management/update-facility"
                        : JSON.parse(currentAsset).assetType ===
                            "5a8e302f-feef-435a-a57d-803af7590702"
                          ? "/asset-management/update-equipment"
                          : JSON.parse(currentAsset).assetType ===
                              "5a8e302f-feef-435a-a57d-803af7590703"
                            ? "/asset-management/update-part"
                            : "/asset-management/update-part",
                    );
                  }}
                  style={{
                    backgroundColor: isTimerRunning ? "#95A7C6" : "#fafafa",
                    cursor: disableTracking ? "default" : "pointer",
                  }}
                >
                  <p
                    className="margin-0 start-text"
                    style={{
                      color: isTimerRunning && "#ffffff",
                      opacity: disableTracking ? "50%" : "100%",
                    }}
                  >
                    {isTimerRunning ? "Stop" : "Start"}
                  </p>
                  {isTimerRunning ? (
                    <img alt="" src={Stop} />
                  ) : (
                    <img
                      alt=""
                      src={disableTracking ? TriangleLight : Triangle}
                      style={{ marginTop: "5px" }}
                    />
                  )}
                </div>
              </div>
            )}
        </div>
      </div>
    </Modal>
  );
};
